import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerLoginRoutingModule } from './customer-login-routing.module';
import { CustomerLoginComponent } from './customer-login.component';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { CoModule } from '../../core/modules/common/co.module';
@NgModule({
  declarations: [
    CustomerLoginComponent
  ],
  imports: [
    CommonModule,
    CustomerLoginRoutingModule,
    FlexModule,
    MatButtonModule,
    CoModule
  ]
})
export class CustomerLoginModule { }
